import React from 'react';

import { Product } from '../types';
import './ProductTooltip.css';

interface ProductTooltipProps {
    product: Product | any; // Using any for flexibility with backend response structure
    position: { x: number; y: number };
    onClose?: () => void;
    onClick?: () => void;
}

const ProductTooltip: React.FC<ProductTooltipProps> = ({ product, position, onClose, onClick }) => {


    if (!product) return null;

    // Format price if available
    const formattedPrice = product.price
        ? new Intl.NumberFormat('tr-TR', { style: 'currency', currency: product.currency || 'TRY' }).format(product.price)
        : '';

    return (
        <div
            className="product-tooltip"
            style={{
                left: `${position.x}%`,
                top: `${position.y}%`
            }}
            onClick={(e) => {
                e.stopPropagation();
                onClick && onClick();
            }}
        >
            <div className="product-tooltip-content">
                <div className="product-tooltip-image-container">
                    <img
                        src={product.imageUrl || product.image || (product.images && product.images[0])}
                        alt={product.name || product.title}
                        className="product-tooltip-image"
                    />
                </div>
                <div className="product-tooltip-info">
                    <h4 className="product-tooltip-name">{product.name || product.title}</h4>
                    <span className="product-tooltip-category">{product.category}</span>
                    {formattedPrice && <span className="product-tooltip-price">{formattedPrice}</span>}


                </div>
            </div>
            {/* Arrow pointing to the dot */}
            <div className="product-tooltip-arrow"></div>
        </div>
    );
};

export default ProductTooltip;
